export default [
  {
    url: "/dashboard/analytics",
    name: "Dashboard",
    slug: "Dashboard",
    icon: "HomeIcon",
    i18n: "Dashboard",
    permission: "Dashboard",
  },
  // CustomerManagemnet
  {
    url: null,
    name: "CustomerManagemnet",
    slug: "CustomerManagemnet",
    icon: "BriefcaseIcon",
    i18n: "مدیریت طرفهای تجاری",
    permission:
      "GetAgentRecipientsByOwnerIdInShipping|GetAllByAgentInfo|GetAllCustomersByType|CreateAgentLegal|CreateAgentIndividual|GetAgentById|CreatePromoterIndividual|CreatePromoterLegal|AssignPromoterPlan|UnAssignPromoterPlan|GetPartyAccountsByOwner|GetAllSoldItemsByOwner|GetALLParty|GetAllDocumentSetting",
    // GetAllSaleAgentQuota|
    submenu: [
      {
        url: "/Customers/Index",
        name: "Customers",
        slug: "Customers",
        i18n: "Customers",
        specificPermission: "GetAllCustomersByType",
        // specificPermission: "CreateIndividualCustomer|CreateCustumerLegal"
      },

      {
        url: "/Agents/Index",
        name: "Agents",
        slug: "Agents",
        i18n: "Agents",
        specificPermission:
          "GetAllByAgentInfo|CreateAgentLegal|CreateAgentIndividual|GetAllSaleAgentQuota|GetAgentRecipientsByOwnerIdInShipping|GetAgentById",
      },

      {
        url: "/Suppliers/Index",
        name: "Suppliers",
        slug: "Suppliers",
        i18n: "Suppliers",
        specificPermission:
          "CreateSupplierLegal|ModifySupplierLegal|CreateSupplierLegalByExcelFile|GetAllSupplierLegal|GetSupplierLegalById|CreateSupplierIndividual|ModifyIndividualSupplier|CreateSupplierIndividualByExcelFile|GetAllIndividual|GetSupplierIndividualById|AssignDocument|UnAssignDocument|GetAllSuppliersByOwnerId|GetAllBySupplierInfo|GetSupplierBySocialSecurityNumber|GetAllSupplierByName|GetAllSupplierQueryTinyInfoByName| GetSupplierDocuments|GetSuppliersWithExcelFile",
      },
      {
        url: "/SalesPartners/Index",
        name: "SalesPartners",
        slug: "SalesPartners",
        i18n: "SalesPartners",
        specificPermission:
          "CreatePromoterIndividual|CreatePromoterLegal|AssignPromoterPlan|UnAssignPromoterPlan|GetPartyAccountsByOwner|GetAllSoldItemsByOwner",
        // "CreatePromoterIndividual|CreatePromoterLegal|AssignPromoterPlan|UnAssignPromoterPlan|GetPartyAccountsByOwner|GetAllFinancialTransactions|GetAllSoldItemsByOwner"
      },
      {
        url: "/Parties/Index",
        name: "Parties",
        slug: "Parties",
        i18n: "Parties",
        specificPermission: "GetALLParty",
      },
      {
        url: "/CustomersSetting/Index",
        name: "Setting",
        slug: "Setting",
        i18n: "Setting",
        specificPermission: "GetAllDocumentSetting",
      },
    ],
  },
  // ProductManagement
  {
    url: null,
    name: "ProductManagement",
    slug: "ProductManagement",
    icon: "PackageIcon",
    i18n: "ProductManagement",
    permission:
      "GetAllGenericProduct|CreateSpecificProduct|GetAllSpecificProductsByExcelFIle|CreateSpecificProductByExcelFile|DeleteSpecificProduct|ModifySpecificProduct|GetActualProductbyId|ModifyActualProduct|ModifyProductAttribute|GetPictureByActualProduct|AttachFileActualProduct|UnAttachFileActualProduct|ModifyPictureActualProduct|GetAllActualProductsExcelFile|CreateActualProduct|DeleteActualProduct|CreateActualProductByExcelFile|GetVideoByActualProduct|CreatePromotionCategory|ModifyPromotionCategory|DeletePromotionCategory|UnAssignGenericProductItem|AssignGenericProductItem|DeleteGenericProduct|CreateGenericProduct|GetGenericProductById|DeleteAttribute|ModifyAttribute|GetAllAttribute|CreateProductColor|ModifyProductColor|DeleteProductColor|DeleteBrand|ModifyBrand|CreateBrand|CreateWarranty|ModifyWarranty|DeleteWarranty|ModifyPictureActualProduct|UnAttachFileActualProduct|AttachFileActualProduct|GetPictureByActualProduct|UpdateConfigurableProduct|DeleteConfigurableProduct|CreateConfigurableProduct|GetConfigurableProductById|GetAllProductsKhadamatWarrantyByKeyword",
    submenu: [
      {
        url: "/SpecificProduct/List",
        name: "Items",
        slug: "Items",
        i18n: "Items",
        specificPermission:
          "CreateSpecificProduct|GetAllSpecificProductsByExcelFIle|CreateSpecificProductByExcelFile|DeleteSpecificProduct|ModifySpecificProduct",
      },
      {
        url: "/ActualProduct/List",
        name: "Products",
        slug: "Products",
        i18n: "Products",
        specificPermission:
          "GetActualProductbyId|ModifyActualProduct|ModifyProductAttribute|GetPictureByActualProduct|AttachFileActualProduct|UnAttachFileActualProduct|ModifyPictureActualProduct|GetAllActualProductsExcelFile|CreateActualProduct|DeleteActualProduct|CreateActualProductByExcelFile|GetVideoByActualProduct",
      },
      {
        url: "/Categories/Index",
        name: "Categories",
        slug: "Categories",
        i18n: "Categories",
        specificPermission:
          "CreatePromotionCategory|ModifyPromotionCategory|DeletePromotionCategory",
      },
      {
        url: "/GenericProduct/Index",
        name: "GenericProducts",
        slug: "GenericProducts",
        i18n: "GenericProducts",
        specificPermission:
          "GetAllGenericProduct|UnAssignGenericProductItem|AssignGenericProductItem|DeleteGenericProduct|CreateGenericProduct|GetGenericProductById|DeleteAttribute|ModifyAttribute|GetAllAttribute",
      },
      {
        url: "/Colors/Index",
        name: "Colors",
        slug: "Colors",
        i18n: "Colors",
        specificPermission:
          "CreateProductColor|ModifyProductColor|DeleteProductColor",
      },
      {
        url: "/Brands/Index",
        name: "Brands",
        slug: "Brands",
        i18n: "Brands",
        specificPermission: "DeleteBrand|ModifyBrand|CreateBrand",
      },
      {
        url: "/Adjectives/Index",
        name: "Adjectives",
        slug: "Adjectives",
        i18n: "Adjectives",
        specificPermission: "DeleteBrand|ModifyBrand|CreateBrand",
      },
      {
        url: "/TermsOfWarrantyProducts/Index",
        name: "TermsOfWarrantyProducts",
        slug: "TermsOfWarrantyProducts",
        i18n: "TermsOfWarrantyProducts",
        specificPermission: "GetAllProductsKhadamatWarrantyByKeyword",
      },
      {
        url: "/Warranties/Index",
        name: "Warranties",
        slug: "Warranties",
        i18n: "Warranties",
        specificPermission: "CreateWarranty|ModifyWarranty|DeleteWarranty",
      },
      {
        url: "/ConfigurableProducts/List",
        name: "ConfigurableProducts",
        slug: "ConfigurableProducts",
        i18n: "ConfigurableProducts",
        specificPermission:
          "GetAllGenericProduct|ModifyPictureActualProduct|UnAttachFileActualProduct|AttachFileActualProduct|GetPictureByActualProduct|UpdateConfigurableProduct|DeleteConfigurableProduct|CreateConfigurableProduct|GetConfigurableProductById",
      },
    ],
  },
  // WarehouseManagement
  {
    url: null,
    name: "WarehouseManagement",
    slug: "WarehouseManagement",
    icon: "ArchiveIcon",
    i18n: "WarehouseManagement",
    permission:
      "GetAllStock|GetKardexTransactionOfStocks|GetAllInventoryBalances|GetAllInventoriesStocksBalances|CreateWarehouse|DeleteWarehouse|ModifyWarehouse|GetAllWarehouse|AddShelve|ModifyShelve|RemoveShelve|CheckInWithExcelFile|GetCheckIns|RegisterCheckIn|GetInventoryTransactionItemsByInventoryTransaction|GetInventoryTransactionHeader|GetSerialsOfStock|CheckOutWithExcelFile|RegisterCheckOut|GetCheckOutForDraftOrderTransactionById|CreateOrder|GetPackagesInfo|GetStockDraftOrderForPrint|GetDischargePermissionByIdAndStoreId|GetRecipientInfoBydraftOrderId",

    // GetInventoryTransactionHeader|RegisterCheckOut|GetCheckOutForDraftOrderTransactionById|GetStockDraftOrderForPrint|CreateOrder|GetDischargePermissionById|GetRecipientInfoBydraftOrderId|GetPackagesInfo|GetDischargePermissionById|ChangeStateToReject|ChangeStateToConfirm|GetRecipientInfoBydraftOrderId|GetRecipientInfoBydraftOrderId|GetStockDraftOrderById|CreateDischargePermission|RegisterCheckOutForDraftOrder|RegisterTransferByExcelFile|RegisterTransfer|GetTransferItems|GetTransferHeader|GetInventoryTransactionItemsByInventoryTransaction|GetSerialsOfStock"
    submenu: [
      {
        url: "/WarehouseProducts/Index",
        name: "Products",
        slug: "Products",
        i18n: "Products",
        specificPermission: "GetAllStock",
      },
      {
        url: "/Warehouse/Index",
        name: "Warehouses",
        slug: "Warehouses",
        i18n: "Warehouses",
        specificPermission:
          "CreateWarehouse|DeleteWarehouse|ModifyWarehouse|GetAllWarehouse|AddShelve|ModifyShelve|RemoveShelve",
      },
      {
        url: "/CheckInTransactions/Index",
        name: "CheckInTransactions",
        slug: "CheckInTransactions",
        i18n: "CheckInTransactions",
        specificPermission:
          "CheckInWithExcelFile|GetCheckIns|RegisterCheckIn|GetInventoryTransactionItemsByInventoryTransaction|GetInventoryTransactionHeader|GetSerialsOfStock",
      },
      {
        url: "/InventoryReservation/Index",
        name: "InventoryReservation",
        slug: "InventoryReservation",
        i18n: "InventoryReservation",
        specificPermission: "CreateReserve|CreateRecharge",
      },
      {
        url: "/InventoryReservations/Index",
        name: "InventoryReservations",
        slug: "InventoryReservations",
        i18n: "InventoryReservations",
        specificPermission: "GetAllReservation",
      },
      {
        url: "/CheckOutTransactions/Index",
        name: "CheckOutTransactions",
        slug: "CheckOutTransactions",
        i18n: "CheckOutTransactions",
        specificPermission:
          "CheckOutWithExcelFile|RegisterCheckOut|GetInventoryTransactionItemsByInventoryTransaction|GetInventoryTransactionHeader|GetCheckOutForDraftOrderTransactionById|GetSerialsOfStock|CreateOrder|GetPackagesInfo|GetStockDraftOrderForPrint|GetDischargePermissionByIdAndStoreId|GetRecipientInfoByDraftOrderId",
        // "|GetPackagesInfo"
      },
      {
        url: "/DischargePermissions/Index",
        name: "DischargePermissions",
        slug: "DischargePermissions",
        i18n: "DischargePermissions",
        specificPermission:
          "GetDischargePermissionByIdAndStoreId|ChangeStateToReject|ChangeStateToConfirm|GetRecipientInfoBydraftOrderId|GetRecipientInfoBydraftOrderId|GetStockDraftOrderById|CreateDischargePermission|RegisterCheckOutForDraftOrder",
      },
      {
        url: "/TransferTransactions/Index",
        name: "TransferTransactions",
        slug: "TransferTransactions",
        i18n: "TransferTransactions",
        specificPermission:
          "RegisterTransferByExcelFile|RegisterTransfer|GetTransferItems|GetTransferHeader",
      },
      {
        url: "/Cardex/Index",
        name: "Cardex",
        slug: "Cardex",
        i18n: "Cardex",
        specificPermission: "GetKardexTransactionOfStocks",
      },
      {
        url: "/Balance/Index",
        name: "StockBalance",
        slug: "StockBalance",
        i18n: "StockBalance",
        specificPermission:
          "GetAllInventoryBalances|GetAllInventoriesStocksBalances",
      },
      //{
      //  url: '/StockCirculation/Index',
      //  name: "StockCirculation",
      //  slug: "StockCirculation",
      //  i18n: "StockCirculation",
      //},
      //{
      //  url: '/SerialCirculation/Index',
      //  name: "SerialCirculation",
      //  slug: "SerialCirculation",
      //  i18n: "SerialCirculation",
      //},
      //{
      //  url: '/SerialBalance/Index',
      //  name: "SerialBalance",
      //  slug: "SerialBalance",
      //  i18n: "SerialBalance",
      //},
      {
        url: "/InventoryTransactionOperation/Index",
        name: "InventoryTransactionOperation",
        slug: "InventoryTransactionOperation",
        i18n: "InventoryTransactionOperation",
        specificPermission:
          "GetInventoryTransactionItemsByInventoryTransaction",
      },
      {
        url: "/Reports/Index",
        name: "Reports",
        slug: "Reports",
        i18n: "Reports",
        specificPermission: "GetSerialsOfStock",
      },
      {
        url: "/WarehouseHandling/Index",
        name: "WarehouseHandling",
        slug: "WarehouseHandling",
        i18n: "WarehouseHandling",
        specificPermission:
          "CreateStockTaking|ModifyStockTaking|GetAllStockTakingByPageInfo|GetStockTakingById|CreateCountTag|RemoveCountTag|FindContradiction|GetCountTagsByStockTaking|GetAllDecreasesOfContradictions|GetAllInventoryItemsByPageInfo|GetAllIncreasesOfContradictions|CreateCountingGroup|GetCountingGroupsByCountingTagId|AddInventoryItemsToCountingGroup|CompleteCountingOfGroup|CompleteCountingOfCountingTag|GetExcelReportOfAllCountingTagsOfThisStockTaking|GetExcelReportOfItemsCodeBaseOnAllCountingTagsOfThisStockTaking",
      },
      // {
      //   url: "/MomentaryInventory/Index",
      //   name: "MomentaryInventory",
      //   slug: "MomentaryInventory",
      //   i18n: "MomentaryInventory"
      //   // specificPermission: "ProductManagement_ConfigurableProducts_View_List"
      // }
    ],
  },
  
  {
    url: null,
    name: "ProcurementManagement",
    slug: "ProcurementManagement",
    icon: "ShoppingCartIcon",
    i18n: "ProcurementManagement",
    permission: "CreateDepartment|ModifyDepartment|GetAllDepartmentsByPaging|DeleteDepartment|CreateUnitOfMeasure|ModifyUnitOfMeasure|GetAllUnitOfMeasuresByPaging|DeleteUnitOfMeasure|CreatePurchaseRequest|ModifyPurchaseRequest|ClosePurchaseRequest|ConfirmPurchaseRequest|RejectPurchaseRequest|GetPurchaseRequestById|GetAllPurchaseRequestByPaging|GotoClose|GotoConfirm|GotoReject|GetAllPurchaseOrdersByPaging|UpdateItemCodeOfPurchaseOrderItem|SetCurrencyType|UpdateUnitPriceOfPurchaseOrderItem|UpdateDeductionAndIncreasesOfPurchaseOrder|GetPurchaseOrderById|GotoConfirm|GotoReject|GetPurchaseInvoiceById|GetAllPurchaseInvoicesByPaging|GotoClose|UpdateCurrencyInfoCommand|UpdateDeductionAndIncreasesOfPurchaseInvoice",
    submenu: [
      {
        url: "/ProcurementManagement/PurchaseRequest",
        name: "PurchaseRequest",
        slug: "PurchaseRequest",
        i18n: "PurchaseRequest",
        specificPermission: "CreatePurchaseRequest|ModifyPurchaseRequest|GetPurchaseRequestById|GetAllPurchaseRequestByPaging",
      },
      {
        url: "/ProcurementManagement/PurchaseOrder",
        name: "PurchaseOrder",
        slug: "PurchaseOrder",
        i18n: "PurchaseOrder",
        specificPermission: "GotoClose|GotoConfirm|GotoReject|GetAllPurchaseOrdersByPaging|UpdateItemCodeOfPurchaseOrderItem|SetCurrencyType|UpdateUnitPriceOfPurchaseOrderItem|UpdateDeductionAndIncreasesOfPurchaseOrder|GetPurchaseOrderById",
      },
      {
        url: "/ProcurementManagement/PreInvoice",
        name: "PreInvoice",
        slug: "PreInvoice",
        i18n: "PreInvoice",
        specificPermission: "GotoConfirm|GotoReject|GetPurchaseInvoiceById|GetAllPurchaseInvoicesByPaging|GotoClose|UpdateCurrencyInfoCommand|UpdateDeductionAndIncreasesOfPurchaseInvoice",
      },
      {
        url: "/ProcurementManagement/DepartmansList",
        name: "Categories",
        slug: "Categories",
        i18n: "Categories",
        specificPermission: "CreateDepartment|ModifyDepartment|GetAllDepartmentsByPaging|DeleteDepartment",
      },
      {
        url: "/ProcurementManagement/Units",
        name: "Unit",
        slug: "Unit",
        i18n: "Unit",
        specificPermission: "CreateUnitOfMeasure|ModifyUnitOfMeasure|GetAllUnitOfMeasuresByPaging|DeleteUnitOfMeasure",
      },
    ],
  },
  // SaleManagemnet
  {
    url: null,
    name: "SaleManagemnet",
    slug: "SaleManagemnet",
    icon: "ShoppingBagIcon",
    i18n: "SaleManagemnet",
    permission:
      "GetAllContract|GetAllAgentSegmentInfos|GetSaleReportChartData|GetSaleReportChartHeaderData|GetAllDraftOrderById|GetClosedBasketById|ChangeStateToConfirm|GetOrderById|GetReturnOrderById|CreateSalePerson|DeleteSalePerson|GetAgentsOfSalePerson|RemoveAgentInfoFromSalePerson|AddAgentInfoToSalePerson|AddSaleProductManagerSegmentInfo|RemoveSaleProductManagerSegmentInfo|ChargeByExcelFile|GetAllQuotaTransactionItem|DischargeByExcelFile|DeleteSaleProductManager|CreateSaleProductManager|GetSegmentsInfoBySaleProductManager|AddSaleProductManagerSegmentInfo|RemoveSaleProductManagerSegmentInfo|AddSaleProductManagerContractInfo|RemoveSaleProductManagerContractInfo|GetAllSaleProductManager|GetContractsInfoBySaleProductManager|GetAllBeneficiaryRuleWithPaging|CreatePromoterPlan|ModifyName|RemovePromoterPlan|CreateSegment|ModifySegment|RemoveSegment|GetAllProductInfos|RemoveProductInfo|AddProductInfo|UnAssignBeneficiaryRule|AssignBeneficiaryRule|GetAllVoucher|CreateVoucher|GetAllSaleAgentQuotaByPageInfo|GetAllSaleAgentQuotaWithKeyword",
    submenu: [
      {
        url: "/DraftOrders/Index",
        name: "DraftOrders",
        slug: "DraftOrders",
        i18n: "DraftOrders",
        specificPermission:
          "GetAllDraftOrderById|GetClosedBasketById|ChangeDischargePermissionStateToConfirm",
      },
      {
        url: "/Orders/Index",
        name: "Orders",
        slug: "Orders",
        i18n: "Orders",
        specificPermission: "GetOrderById",
      },
      {
        url: "/ReturnOrders/Index",
        name: "ReturnOrders",
        slug: "ReturnOrders",
        i18n: "ReturnOrders",
        specificPermission: "GetReturnOrderById",
      },
      {
        url: "/SaleProducts/Index",
        name: "Products",
        slug: "Products",
        i18n: "Products",
        specificPermission:
          "GetAllSaleSpecificProducts|GetAllSpecificProductsExcel",
      },
      {
        url: "/Pricing/Index",
        name: "Pricing",
        slug: "Pricing",
        i18n: "Pricing",
        specificPermission:
          "GetAllPrice|ModifyPricesByExcelFile|GetAllPriceExcelReport|CreatePrice|ModifyPrice",
      },
      {
        url: "/SaleContracts/Index",
        name: "SaleContracts",
        slug: "SaleContracts",
        i18n: "SaleContracts",
        specificPermission:
          "GetAllContract|CreateContract|DeleteContract|GetContractById|ModifyContract",
      },
      {
        url: "/Vouchers/Index",
        name: "Vouchers",
        slug: "Vouchers",
        i18n: "Vouchers",
        specificPermission: "GetAllVoucher|CreateVoucher",
      },
      {
        url: "/PublicDiscountCodes/Index",
        name: "DiscountCodes",
        slug: "DiscountCodes",
        i18n: "DiscountCodes",
        specificPermission: "CreateVoucher",
        // "CreateVoucher|219219|220220"
      },
      {
        url: "/ReportsOrder/Index",
        name: "ReportsOrder",
        slug: "ReportsOrder",
        i18n: "ReportsOrder",
        // specificPermission: "111111111"
        specificPermission:
          "GetAllSaleAgentQuotaByPageInfo|GetSaleReportChartData|GetSaleReportChartHeaderData",
        // "216216|218218"
      },
      {
        url: "/ReportsDraftOrder/Index",
        name: "ReportsDraftOrder",
        slug: "ReportsDraftOrder",
        i18n: "ReportsDraftOrder",
        specificPermission: "GetSaleReportChartData",
      },
      {
        url: "/SalesPersons/Index",
        name: "SalesPersons",
        slug: "SalesPersons",
        i18n: "SalesPersons",
        specificPermission:
          "GetAllContractTinyInfo|GetAllAgentSegmentInfos|CreateSalePerson|DeleteSalePerson|GetAgentsOfSalePerson|RemoveAgentInfoFromSalePerson|AddAgentInfoToSalePerson|AddSaleProductManagerSegmentInfo|RemoveSaleProductManagerSegmentInfo",
      },
      // {
      //   url: "/ProductSegment/Index",
      //   name: "ProductSegment",
      //   slug: "ProductSegment",
      //   i18n: "سگمنت" + " ( غیرفعال )",
      //   specificPermission: "SaleManagemnet_ProductSegment_View_List"
      // },
      {
        url: "/Quotas/Index",
        name: "Quotas",
        slug: "Quotas",
        i18n: "Quotas",
        specificPermission:
          "ChargeByExcelFile|GetAllQuotaTransactionItem|DischargeByExcelFile|GetAllSaleAgentQuotaWithKeyword|GetAllWebsiteQuotaQueryWithKeyword|GetAllSaleAgentQuotaWithInventoriesQueryWithKeyword|GetAllSaleAgentQuotaWithItemCode",
      },
      {
        url: "/BasicDefinitions/Index",
        name: "BasicDefinitions",
        slug: "BasicDefinitions",
        i18n: "BasicDefinitions",
        specificPermission:
          "GetAllBeneficiaryRuleWithPaging|CreatePromoterPlan|ModifyName|RemovePromoterPlan|CreateSegment|ModifySegment|RemoveSegment|GetAllProductInfos|RemoveProductInfo|AddProductInfo|UnAssignBeneficiaryRule|AssignBeneficiaryRule",
        // "CreateSegment|ModifySegment|RemoveSegment|GetAllProductInfos|AddProductInfo|RemoveProductInfo"
      },
      {
        url: "/SaleProductManagers/Index",
        name: "SaleProductManagers",
        slug: "SaleProductManagers",
        i18n: "SaleProductManagers",
        specificPermission:
          "DeleteSaleProductManager|CreateSaleProductManager|GetSegmentsInfoBySaleProductManager|AddSaleProductManagerSegmentInfo|RemoveSaleProductManagerSegmentInfo|AddSaleProductManagerContractInfo|RemoveSaleProductManagerContractInfo|GetAllSaleProductManager|GetContractsInfoBySaleProductManager",
      },
      {
        url: "/SaleTargets/Index",
        name: "SaleTargets",
        slug: "SaleTargets",
        i18n: "SaleTargets",
        specificPermission:
          "CreateSaleTarget|RemoveSaleTarget|AddSegmentsByExcelFile|AddSaleAgentTargetsOnSegmentTargetsByExcelFile|GetAllByPageInfo|GetAllSegmentTarget|GetAllSaleAgentTarget",
      },
    ],
  },
  // BasketManagement
  {
    url: null,
    name: "BasketManagement",
    slug: "BasketManagement",
    icon: "ClipboardIcon",
    i18n: "BasketManagement",
    permission:
      "ApplyImmediateDiscountToBasket|GetClosedBasketById|ChangeStateToDeliver|ChangeStateToRejectForBusinessToCustomerBasket|CreateCashBankPayment|GetSaleAgentBasketById|ChangeStateToDeliver",
    submenu: [
      //{
      //  url: '/InternalOrders/Index',
      //  name: "InternalOrders",
      //  slug: "InternalOrders",
      //  i18n: "InternalOrders",
      //},
      {
        url: "/WebSiteBaskets/Index",
        name: "WebSiteBaskets",
        slug: "WebSiteBaskets",
        i18n: "WebSiteBaskets",
        specificPermission:
          "GetClosedBasketById|ChangeStateToDeliver|ChangeStateToRejectForBusinessToCustomerBasket|CreateCashBankPayment",
      },
      {
        url: "/ChannelBaskets/Index",
        name: "ChannelBaskets",
        slug: "ChannelBaskets",
        i18n: "ChannelBaskets",
        specificPermission:
          "ApplyImmediateDiscountToBasket|GetSaleAgentBasketById|ChangeStateToDeliver",
      },
      //{
      //  url: '/DirectSaleOrders/Index',
      //  name: "DirectSaleOrders",
      //  slug: "DirectSaleOrders",
      //  i18n: "DirectSaleOrders",
      //},
      //{
      //  url: '/CorporateOrders/Index',
      //  name: "CorporateOrders",
      //  slug: "CorporateOrders",
      //  i18n: "CorporateOrders",
      //},
    ],
  },
  // shipping-management
  {
    url: null,
    name: "ShippingManagement",
    slug: "ShippingManagement",
    icon: "TruckIcon",
    i18n: "ShippingManagement",
    permission:
      "GetAllOperator|CreateOperator|GetAllByOperator|ChangePackageStateToOperatorApproved|ChangePackageStateToDelivered|CreateBike|CreateTruck|GetAllTransport|CreateTransportFleet|GetAllTransportsFleet|GetAllPackage|AssignTransportFleetToPackage|AssignOperatorToPackage|ChangePackageStateToFinished",
    submenu: [
      {
        url: "/Operators/Index",
        name: "Operators",
        slug: "Operators",
        i18n: "Operators",
        specificPermission: "GetAllOperator|CreateOperator",
      },
      {
        url: "/TransportTools/Index",
        name: "TransportTools",
        slug: "TransportTools",
        i18n: "TransportTools",
        specificPermission: "CreateBike|CreateTruck|GetAllTransport",
      },
      {
        url: "/TransportFleets/Index",
        name: "TransportFleets",
        slug: "TransportFleets",
        i18n: "TransportFleets",
        specificPermission: "CreateTransportFleet|GetAllTransportsFleet",
      },
      {
        url: "/Package/Index",
        name: "Packages",
        slug: "Packages",
        i18n: "Packages",
        specificPermission:
          "GetAllPackage|AssignOperatorToPackage|ChangePackageStateToFinished",
      },
      {
        url: "/OperationOperators/Index",
        name: "OperationOperators",
        slug: "OperationOperators",
        i18n: "OperationOperators",
        specificPermission:
          "GetAllByOperator|ChangePackageStateToOperatorApproved|ChangePackageStateToDelivered",
      },
    ],
  },

  // FinancialManagement
  {
    url: null,
    name: "FinancialManagement",
    slug: "FinancialManagement",
    icon: "FileTextIcon",
    i18n: "FinancialManagement",
    permission: "GetALLBankPayment",
    submenu: [
      {
        url: "/BankPortalPayments/Index",
        name: "BankPortalPayments",
        slug: "BankPortalPayments",
        i18n: "BankPortalPayments",
        specificPermission: "GetALLBankPayment",
      },

    ],
  },

  // CreditManagement
  {
    url: "CreditManagement/Index",
    name: "CreditManagement",
    slug: "CreditManagement",
    icon: "CreditCardIcon",
    i18n: "CreditManagement",
    permission:
      "CreateFloatingAccount |ChangeStateToConfrim |AssignConnectedAccounts|GetAllFirstLevelFloatingAccounts|GetAllChildAccounts|GetAllAccountsByParentAccountId|GetAllLastLevelOfFloatingAccounts|CreateGroupAccount|GetAllGroupsAccounts|CreateGeneralAccount|GetAllGeneralsAccounts|CreateSubsidiaryAccount|GetAllSubsidiaryAccounts|CreateDetailAccount|GetAllDetailsAccounts|GetAllSubsidiaryAndDetailAccounts|CreateExpense|CreateFundReplenishment|AddFileAttachmentCommand|GetAllExpense|GetAllFundReplenishment|GetAllExpenseByFundReplenishmentId|GetAllFiles|GetPartyAccount|GetAllSubsidiaryAndDetailAccounts|GetAllAccountsOfPartiesInCreditManagement|GetAllPartiesByNameInCreditManagement|GetAllAccountsOfPartiesByNameInCreditManagement|GetPartyAccountsByOwner",
    submenu: [
      // {
      //   url: "/CreditManagement/CreditInquiry/Index",
      //   name: "مانده اعتبارات",
      //   slug: "مانده اعتبارات",
      //   i18n: "مانده اعتبارات",
      //   specificPermission: "GetAllAccountsOfPartiesByNameInCreditManagement",
      // },
      

      {
        url: "/Party/Index",
        name: "طرف های تجاری",
        slug: "طرف های تجاری",
        i18n: "طرف های تجاری",
        specificPermission: "CreateCostCenter|AssignAccountReference|DeleteCostCenter|GetAllByPaging|GetAllAccountReferenceInfos|GetAllCostCentersByParentAccountId|GetPartyAccount|GetAllSubsidiaryAndDetailAccounts|GetAllAccountsOfPartiesInCreditManagement|GetAllPartiesByNameInCreditManagement|GetAllAccountsOfPartiesByNameInCreditManagement|GetPartyAccountsByOwner",
      },
      // {
      //   url: "/CreditManagement/Transactions/Index",
      //   name: "گزارش تراکنش‌ها",
      //   slug: "گزارش تراکنش‌ها",
      //   i18n: "گزارش تراکنش‌ها",
      //   specificPermission: "GetAllFinancialTransactions",
      // },
      {
        url: "/CreditManagement/CostCenter/Index",
        name: "مرکز هزینه",
        slug: "مرکز هزینه",
        i18n: "مرکز هزینه",
        specificPermission: "GetAllPettyCashes|AssignAccounts|GetAllAccounts|GetAllSubsidiaryAndDetailAccounts|CreateCostCenter|AssignAccountReference|DeleteCostCenter|GetAllByPaging|GetAllAccountReferenceInfos|GetAllCostCentersByParentAccountId",
      },
      // {
      //   url: "/CreditManagement/CostTitle/Index",
      //   name: "عنوان هزینه",
      //   slug: "عنوان هزینه",
      //   i18n: "عنوان هزینه",
      //   specificPermission: "GetAllFinancialTransactions",
      // },
      {
        url: "/CreditManagement/Voucher/Index",
        name: "اسناد مالی",
        slug: "اسناد مالی",
        i18n: "اسناد مالی",
        specificPermission: "Vouchers|GetAllVouchers|GetAllArticles|Report",
      },
      {
        url: "/PettyCash/Index",
        name: "PettycashManagement",
        slug: "PettycashManagement",
        i18n: "PettycashManagement",
        permission: "GetAllSubsidiaryAndDetailAccounts|GetAllPettyCashes|AssignAccounts|GetAllAccounts|GetAllSubsidiaryAndDetailAccounts|CreateExpense|CreateFundReplenishment|AddFileAttachmentCommand|GetAllExpense|GetAllFundReplenishment|GetAllExpenseByFundReplenishmentId|GetAllFiles",
        submenu: [

          {
            url: "/PettyCash/Index",
            name: "Pettycashs",
            slug: "Pettycashs",
            i18n: "Pettycashs",
            specificPermission: "GetAllSubsidiaryAndDetailAccounts|GetAllPettyCashes|AssignAccounts|GetAllAccounts",
          },
          {
            url: "/PettyCash/Reports",
            name: "گزارش تنخواه",
            slug: "گزارش تنخواه",
            i18n: "گزارش تنخواه",
            specificPermission: "GetAllFinancialTransactions|Report|Vouchers",
          },
          {
            url: "/PettyCash/ChargePettycashsAccount",
            name: " حساب تنخواه",
            slug: " حساب تنخواه",
            i18n: " حساب تنخواه",
            specificPermission: "ChangeStateToConfrim | GetAllSubsidiaryAndDetailAccounts|CreateExpense|CreateFundReplenishment|AddFileAttachmentCommand|GetAllExpense|GetAllFundReplenishment|GetAllExpenseByFundReplenishmentId|GetAllFiles",
          },
        ]      
      },
      // {
      //   url: "/CreditManagement/Transactions/Index",
      //   name: "خزانه داری ",
      //   slug: "خزانه داری ",
      //   i18n: "خزانه داری ",
      //   permission: "GetAllFinancialTransactions",
      //   submenu: [

      //     {
      //       url: "/Receipts/Index",
      //       name: "دریافت  ",
      //       slug: "دریافت  ",
      //       i18n: "دریافت ",
      //       specificPermission: "GetAllFinancialTransactions",
      //     },
      //     {
      //       url: "/Payments/Index",
      //       name: "پرداخت",
      //       slug: "پرداخت",
      //       i18n: "پرداخت",
      //       specificPermission: "GetAllFinancialTransactions",
      //     },
      //   ]
      // },
      {
        url: "/CreditManagement/Transactions/Index",
        name: "حساب ها",
        slug: "حساب ها",
        i18n: "حساب ها",
        permission: "GetAllSubsidiaryAndDetailAccounts|CreateFloatingAccount|AssignConnectedAccounts|GetAllFirstLevelFloatingAccounts|GetAllChildAccounts|GetAllAccountsByParentAccountId|GetAllLastLevelOfFloatingAccounts|CreateGroupAccount|GetAllGroupsAccounts|CreateGeneralAccount|GetAllGeneralsAccounts|CreateSubsidiaryAccount|GetAllSubsidiaryAccounts|CreateDetailAccount|GetAllDetailsAccounts",
        submenu: [
          {
            url: "/CreditManagement/AccountGroup/Index",
            name: "گروه حساب ها",
            slug: "گروه حساب ها",
            i18n: "گروه حساب ها",
            specificPermission: "CreateGroupAccount|GetAllGroupsAccounts",
          },
          {
            url: "/CreditManagement/GeneralAccount/Index",
            name: "حساب کل",
            slug: "حساب کل",
            i18n: "حساب کل",
            specificPermission: "CreateGeneralAccount|GetAllGeneralsAccounts",
          },
          {
            url: "/CreditManagement/SubsidiaryAccount/Index",
            name: "حساب معین",
            slug: "حساب معین",
            i18n: "حساب معین",
            specificPermission: "CreateSubsidiaryAccount|GetAllSubsidiaryAccounts",
          },
          {
            url: "/CreditManagement/DetailsAccount/Index",
            name: "حساب تفضیلی",
            slug: "حساب تفضیلی",
            i18n: "حساب تفضیلی",
            specificPermission: "CreateDetailAccount|GetAllDetailsAccounts",
          },
          {
            url: "/CreditManagement/FloatingAccount/Index",
            name: "حساب شناوری",
            slug: "حساب شناوری",
            i18n: "حساب شناوری",
            specificPermission: "GetAllSubsidiaryAndDetailAccounts|CreateFloatingAccount|AssignConnectedAccounts|GetAllFirstLevelFloatingAccounts|GetAllChildAccounts|GetAllAccountsByParentAccountId|GetAllLastLevelOfFloatingAccounts",
          },
        ],
      },

    ],
  },
  // FinancialReports
  {
    url: null,
    name: "FinancialReports",
    slug: "FinancialReports",
    icon: "BookIcon",
    i18n: "FinancialReports",
    permission: "TadbirReports",
    submenu: [
      {
        url: "/TadbirOrders/Index",
        name: "TadbirOrders",
        slug: "TadbirOrders",
        i18n: "TadbirOrders",
        specificPermission: "TadbirReports",
      },
      {
        url: "/TadbirCustomers/Index",
        name: "TadbirCustomers",
        slug: "TadbirCustomers",
        i18n: "TadbirCustomers",
        specificPermission: "TadbirReports",
      },
      {
        url: "/TadbirReceipts/Index",
        name: "TadbirReceipts",
        slug: "TadbirReceipts",
        i18n: "TadbirReceipts",
        specificPermission: "TadbirReports",
      },
    ],
  },
  // UserManagement
  {
    url: null,
    name: "UserManagement",
    slug: "UserManagement",
    icon: "UsersIcon",
    i18n: "UserManagement",
    permission:
      "GetAllUser|GetUsersByRoleId|GetAllPermissionsByRoleId|DeleteRole|CreateRole|ModifyRole|CreatePermission|ModifyPermission|DeletePermission|CreateUser",
    submenu: [
      {
        url: "/Users/Index",
        name: "Users",
        slug: "Users",
        i18n: "Users",
        specificPermission: "GetAllUser",
      },
      {
        url: "/Roles/Index",
        name: "Roles",
        slug: "Roles",
        i18n: "Roles",
        specificPermission:
          "GetUsersByRoleId|GetAllPermissionsByRoleId|DeleteRole|CreateRole|ModifyRole",
      },
      {
        url: "/Permissions/Index",
        name: "Permissions",
        slug: "Permissions",
        i18n: "Permissions",
        specificPermission:
          "CreatePermission|ModifyPermission|DeletePermission",
      },
      {
        url: "/SubmitNewUser/Index",
        name: "SubmitNewUser",
        slug: "SubmitNewUser",
        i18n: "SubmitNewUser",
        specificPermission: "CreateUser",
      },
    ],
  },
  // ContentManagement
  {
    url: null,
    name: "ContentManagement",
    slug: "ContentManagement",
    icon: "BookOpenIcon",
    i18n: "ContentManagement",
    permission:
      "CreateMenu|ModifyMenu|DeleteMenu|AssignProductsToMenu|UnAssignProductsFromMenu|CreateBanner|ModifyBanner|DeleteBanner|CreateProductCollection|DeleteProductCollection|UnAssignProductsFromProductCollection|AssignProductsToProductCollection|ModifyProductCollection|CreatePage|ModifyPage|DeletePage|CreatePost|ModifyPost|DeletePost|ModifyCmsCategory|DeleteCategory|CreateCategory|ModifyTag|DeleteTag|CreateTag|ModifyCmsCategory|CreateForum|ModifyForum|ModifyFaq|CreateFaq|DeleteFaq|CreateFaqCategory|ModifyFaqCategory|DeleteFaqCategory|WebsiteVisitors|YaldaEvent|AssignAnswer|GetAllSuggestions|GetAllSuggestionsWithOutAnswer|GetAllSuggestionWithAnswer",
    submenu: [
      {
        url: "/Contents",
        name: "Contents",
        slug: "Contents",
        i18n: "Contents",
        specificPermission: "",
      },
      {
        url: "/Menus/Index",
        name: "Menus",
        slug: "Menus",
        i18n: "Menus",
        specificPermission:
          "CreateMenu|ModifyMenu|DeleteMenu|AssignProductsToMenu|UnAssignProductsFromMenu",
      },
      {
        url: "/Banners/Index",
        name: "Banners",
        slug: "Banners",
        i18n: "Banners",
        specificPermission: "CreateBanner|ModifyBanner|DeleteBanner",
      },
      {
        url: "/ProductCollection/Index",
        name: "ProductCollection",
        slug: "ProductCollection",
        i18n: "ProductCollection",
        specificPermission:
          "CreateProductCollection|DeleteProductCollection|UnAssignProductsFromProductCollection|AssignProductsToProductCollection|ModifyProductCollection",
      },
      {
        url: "/Pages/Index",
        name: "Pages",
        slug: "Pages",
        i18n: "Pages",
        specificPermission: "CreatePage|ModifyPage|DeletePage",
      },
      {
        url: "/Blog/Index",
        name: "Blog",
        slug: "Blog",
        i18n: "Blog",
        specificPermission:
          "CreatePost|ModifyPost|DeletePost|ModifyCmsCategory|DeleteCategory|CreateCategory|ModifyTag|DeleteTag|CreateTag",
      },
      {
        url: "/ProductCommnets/Index",
        name: "ProductCommnets",
        slug: "ProductCommnets",
        i18n: "ProductCommnets",
        specificPermission: "ModifyCmsCategory",
      },
      {
        url: "/Forums/Index",
        name: "Forums",
        slug: "Forums",
        i18n: "Forums",
        specificPermission: "CreateForum|ModifyForum",
      },
      {
        url: "/FAQ/Index",
        name: "FAQ",
        slug: "FAQ",
        i18n: "FAQ",
        specificPermission:
          "ModifyFaq|CreateFaq|DeleteFaq|CreateFaqCategory|ModifyFaqCategory|DeleteFaqCategory",
      },
      {
        url: "/YaldaEvent/Index",
        name: "YaldaEvent",
        slug: "YaldaEvent",
        i18n: "YaldaEvent",
        specificPermission: "YaldaEvent",
      },
      // {
      //   url: "/RecruitmentRequest/Index",
      //   name: "RecruitmentRequest",
      //   slug: "RecruitmentRequest",
      //   i18n: "RecruitmentRequest",
      //   specificPermission: ""
      // },
      {
        url: "/WebsiteVisitors/Index",
        name: "WebsiteVisitors",
        slug: "WebsiteVisitors",
        i18n: "WebsiteVisitors",
        specificPermission: "WebsiteVisitors",
      },
      {
        url: "/CriticsAndSuggestions/Index",
        name: "CriticsAndSuggestions",
        slug: "CriticsAndSuggestions",
        i18n: "CriticsAndSuggestions",
        specificPermission:
          "AssignAnswer|GetAllSuggestions|GetAllSuggestionsWithOutAnswer|GetAllSuggestionWithAnswer",
      },
    ],
  },

  // NotificationManagement
  {
    url: null,
    name: "NotificationManagement",
    slug: "NotificationManagement",
    icon: "MessageCircleIcon",
    i18n: "NotificationManagement",
    permission:
      "ModifyNotificationTemplate|GetAllNotificationTemplates|GetAllReceiverSettings|CreateReceiver|GetAllReceiversByName",
    submenu: [
      {
        url: "/Notifications/Index",
        name: "Notifications",
        slug: "Notifications",
        i18n: "Notifications",
        specificPermission: "",
      },
      {
        url: "/NotificationTemplate/Index",
        name: "NotificationTemplate",
        slug: "NotificationTemplate",
        i18n: "NotificationTemplate",
        specificPermission:
          "ModifyNotificationTemplate|GetAllNotificationTemplates|GetAllReceiverSettings",
      },
      {
        url: "/Receivers/Index",
        name: "Receivers",
        slug: "Receivers",
        i18n: "Receivers",
        specificPermission: "CreateReceiver|GetAllReceiversByName",
      },
    ],
  },
  // Geography
  {
    url: null,
    name: "Geography",
    slug: "Geography",
    icon: "MapIcon",
    i18n: "Geography",
    permission:
      "CreateCountry|ModifyCountry|DeleteCountry|CreateProvince|ModifyProvince|DeleteProvince|CreateCity|ModifyCity|DeleteCity",
    submenu: [
      {
        url: "/Countries/Index",
        name: "Countries",
        slug: "Countries",
        i18n: "Countries",
        specificPermission: "CreateCountry|ModifyCountry|DeleteCountry",
      },
      {
        url: "/Provinces/Index",
        name: "Provinces",
        slug: "Provinces",
        i18n: "Provinces",
        specificPermission:
          "CreateProvince|ModifyProvince|DeleteProvince",
      },
      {
        url: "/Cities/Index",
        name: "Cities",
        slug: "Cities",
        i18n: "Cities",
        specificPermission: "CreateCity|ModifyCity|DeleteCity",
      },
    ],
  },
];
